import { FileText } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { formatCurrency } from "../../lib/utils";
import { printPayslip, monthLabel, payslipLines } from "../../lib/payslipPrint";

export const PayslipsTab = ({ payslips, settings }) => (
  <Card><CardContent className="p-0 divide-y">
    {payslips.length === 0 && <p className="p-4 text-center text-muted-foreground text-sm">Ainda não tem recibos de vencimento</p>}
    {payslips.map((r) => {
      const { gross, totalDeductions } = payslipLines(r);
      return (
        <div key={r.payroll_id} className="flex justify-between items-center p-3 text-sm gap-3 flex-wrap" data-testid={`payslip-${r.payroll_id}`}>
          <div className="flex-1 min-w-40">
            <p className="font-medium">{monthLabel(r.month)} {r.receipt_number && <span className="text-xs text-muted-foreground font-mono">· {r.receipt_number}</span>}</p>
            <p className="text-xs text-muted-foreground">Bruto <span className="font-mono">{formatCurrency(gross)}</span> · Descontos <span className="font-mono">−{formatCurrency(totalDeductions)}</span> · Líquido <b className="font-mono text-foreground">{formatCurrency(r.net_salary)}</b></p>
          </div>
          <Badge className={r.status === "paid" ? "bg-emerald-500/20 text-emerald-600" : "bg-amber-500/20 text-amber-600"}>{r.status === "paid" ? "Pago" : "Pendente"}</Badge>
          <Button size="sm" variant="outline" onClick={() => printPayslip({ record: r, settings })} data-testid={`print-payslip-${r.payroll_id}`}>
            <FileText className="w-4 h-4 mr-1" /> Recibo
          </Button>
        </div>
      );
    })}
  </CardContent></Card>
);
